<template>
  <div id="Help-Button" @click="callback">
    <font-awesome-icon icon="question" />
  </div>
</template>

<script>
export default {
  props: {
    callback: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style>
/*=============================================
ESCRITORIO GRANDE (LG revisamos en 1366px en adelante)
=============================================*/
@media (min-width: 1200px) {
}
/*=============================================
ESCRITORIO MEDIANO O TABLET HORIZONTAL (MD revisamos en 1024px)
=============================================*/
@media (max-width: 1199px) and (min-width: 992px) {
}
/*=============================================
ESCRITORIO PEQUEÑO O TABLET VERTICAL (SM revisamos en 768px)
=============================================*/
@media (max-width: 991px) and (min-width: 768px) {
  #Help-Button {
    display: none;
  }
}
/*=============================================
MOVIL (XS revisamos en 320px)
=============================================*/
@media (max-width: 767px) {
  #Help-Button {
    display: none;
  }
}
</style>